import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Text } from "../ui/text";
import LanguageIcon from "../ui/icons/LanguageIcon";
import { useState } from "react";

const LanguagePopup = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleChangeLanguage = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger>
        <div
          className={`rounded-[4px] h-[40px] w-[40px] flex items-center justify-center`}
        >
          <LanguageIcon color={isOpen ? "#0AC4B2" : "#4D4D4D"} />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="p-1 w-[140px] flex flex-col gap-[2px]"
        sideOffset={20}
      >
        <DropdownMenuItem
          onClick={() => handleChangeLanguage("en")}
          className="px-[24px] flex justify-center h-[40px]"
        >
          <Text variant={"label-lg"} className="text-grey-20 text-center">
            English
          </Text>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => handleChangeLanguage("jp")}
          className="px-[24px] flex justify-center h-[40px]"
        >
          <Text variant={"label-lg"} className="text-grey-20 text-center">
            日本語
          </Text>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguagePopup;
